import { Components, Theme } from '@mui/material/styles';

/**
 * Create Chip Component Theme
 */
export const createChipTheme = (theme: Theme): Components['MuiChip'] => {
  const { palette } = theme;
  const getColorToken = (color?: string) => {
    if (color === 'success') {
      return {
        backgroundColor: palette.success.light,
        color: palette.success.dark,
        borderColor: palette.success.dark,
      };
    }

    if (color === 'error') {
      return {
        backgroundColor: (palette.error as unknown as Record<string, string>)[
          '50'
        ],
        color: palette.error.main,
        borderColor: palette.error.main,
      };
    }

    if (color === 'warning') {
      return {
        backgroundColor: palette.warning.light,
        color: palette.warning.dark,
        borderColor: palette.warning.dark,
      };
    }

    if (color === 'secondary' || color === 'info') {
      return {
        backgroundColor: palette.secondary.light,
        color: palette.secondary.main,
        borderColor: palette.secondary.main,
      };
    }

    return {
      backgroundColor: palette.background.tertiary,
      color: palette.text.secondary,
      borderColor: palette.text.secondary,
    };
  };

  return {
    styleOverrides: {
      root: ({ ownerState }) => {
        const { variant, color } = ownerState;
        const isOutlined = variant === 'outlined';
        const colorToken = getColorToken(color);

        return {
          borderRadius: 6,
          fontSize: 12,
          '& .MuiChip-label': {
            paddingTop: 4,
            paddingBottom: 4,
          },
          backgroundColor: isOutlined
            ? 'transparent'
            : colorToken.backgroundColor,
          color: colorToken.color,
          borderColor: isOutlined ? colorToken.borderColor : undefined,
        };
      },
    },
  };
};

export default createChipTheme;
